import React from 'react';
import { useNavigate } from "react-router-dom";

import { useSharedData } from '../../Contexts/SharedContext';
import { useLanguage } from '../../Contexts/LanguageContext';

import LanguageMenu from './LanguageMenu';
import ArrowLeft from '../../Elements/Icon/assets/arrow-left.component.svg';

import strings from '../../strings';

const Header = ({
    withBackNavigation = false,
    withLanguageMenu = true,
    navigationSlug,
}) => {
    const { content, loading, error } = useSharedData();
    const { language } = useLanguage();
    const navigate = useNavigate();

    return (
        <div className="header">
            { withBackNavigation ? (
                <button 
                    className="header__back-button" 
                    aria-label={strings.HEADER_BACK_BUTTON_ARIA_LABEL[language]}
                    onClick={() => navigate(navigationSlug || -1)}
                >
                    <ArrowLeft />
                </button>
            ) : null}
            { withLanguageMenu ? (
                <LanguageMenu />
            ) : null}
        </div>
    );
}

export default Header;